import { render, staticRenderFns } from "./PrepaidCard.vue?vue&type=template&id=164ffac6"
import script from "./PrepaidCard.vue?vue&type=script&lang=js"
export * from "./PrepaidCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports